export const getJobs = state => state?.features?.jobs || {};
export const getError = state => getJobs(state)?.error;
export const getJobIds = state => getJobs(state)?.jobIds || [];
export const getTemplates = state => getJobs(state)?.jobTemplates || [];
export const getJobTitles = state => getJobs(state)?.jobTitles || [];
export const getIsLoading = state => getJobs(state)?.isLoading;
export const getFilterOptions = state => state?.features?.jobs?.filterOptions || {};
export const getSortOptions = state => getJobs(state)?.sortOptions || {};
export const getSearchQuery = state => getJobs(state)?.searchQuery || '';
export const getSummary = state => getJobs(state)?.jobSummary || {};

export default {
  getError,
  getJobs,
  getJobIds,
  getIsLoading,
  getFilterOptions,
  getSortOptions,
  getSearchQuery,
  getJobTitles,
  getSummary,
};
